import { faker } from "@faker-js/faker";

import type {
  GetVendorContract200,
  GetVendorContractPathParams,
  GetVendorContractQueryResponse,
} from "../models/GetVendorContract";
import { createContractWithAssociations } from "./createContractWithAssociations";

export function createGetVendorContractPathParams(
  override: NonNullable<Partial<GetVendorContractPathParams>> = {},
): NonNullable<GetVendorContractPathParams> {
  return {
    ...{ vendor_id: faker.number.int(), id: faker.number.int() },
    ...override,
  };
}

/**
 * @description OK
 */
export function createGetVendorContract200(
  override: NonNullable<Partial<GetVendorContract200>> = {},
): NonNullable<GetVendorContract200> {
  return {
    ...{ contract: createContractWithAssociations() },
    ...override,
  };
}

/**
 * @description OK
 */
export function createGetVendorContractQueryResponse(
  override: NonNullable<Partial<GetVendorContractQueryResponse>> = {},
): NonNullable<GetVendorContractQueryResponse> {
  return {
    ...{ contract: createContractWithAssociations() },
    ...override,
  };
}
